import * as React from 'react';

import * as styles from './styles.css';
import { TooltipDesktop } from '@cian/ui-kit';

interface IComparisonContentProps {
  tooltipText?: string;
}

export const ComparisonContent: React.FC<React.PropsWithChildren<IComparisonContentProps>> = ({
  tooltipText,
  children,
}) => {
  if (!tooltipText) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
  }

  return (
    <TooltipDesktop theme="black" placement="left" title={<div className={styles['container']}>{tooltipText}</div>}>
      {children as React.ReactElement<any>}
    </TooltipDesktop>
  );
};
